import React from 'react';
import { Container } from 'react-bootstrap';

function WhyUsStats({ whyUs = null }) {
  const items = [
    { key: 'experience', label: 'Experience', value: whyUs?.experience },
    { key: 'customers', label: 'Customers', value: whyUs?.customers },
    { key: 'toll_free', label: 'Toll Free', value: whyUs?.toll_free },
  ]
    .map((item) => ({
      ...item,
      value: normalizeRichText(item.value),
    }))
    .filter((item) => String(item.value || '').trim());

  if (!items.length) {
    return null;
  }

  return (
    <section className="whyus-section py-4">
      <Container>
        <div className="row g-3">
          {items.map((item) => (
            <div key={item.key} className="col-md-4">
              <div className="whyus-card h-100">
                <div className="whyus-card__label">{item.label}</div>
                {item.key === 'toll_free' ? (
                  <a href={toTelHref(item.value)} className="whyus-card__value">
                    {item.value}
                  </a>
                ) : (
                  <div className="whyus-card__value">{item.value}</div>
                )}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}

function normalizeRichText(value) {
  const source = typeof value === 'string' ? value.trim() : '';

  if (!source) {
    return '';
  }

  if (typeof window === 'undefined') {
    return source.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(source, 'text/html');

  return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
}

function toTelHref(value) {
  const digits = String(value || '').replace(/[^\d+]/g, '');
  return digits ? `tel:${digits}` : '#';
}

export default WhyUsStats;
